__webpack_require__.p = "https://unpkg.com/jupyter-vuetify@1.11.3/dist/";